// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__287B7","title":"styles_title___Eef8"};